import React, { useState } from "react";
import { Checkbox } from "./ui/checkbox";
import { Label } from "./ui/label";
import { Department, User } from ".clients/../types/index"
interface DepartmentSelectorProps {
  departments: Department[];
  selectedDepartments: string[];
  primaryDepartment: string;
  onChange: (departments: string[]) => void;
  onChangePrimary: (departmentId: string) => void;
  showPrimarySelector?: boolean;
}

export function DepartmentSelector({
  departments,
  selectedDepartments,
  primaryDepartment,
  onChange,
  onChangePrimary,
  showPrimarySelector = true
}: DepartmentSelectorProps) {
  const handleToggleDepartment = (departmentId: string, checked: boolean) => {
    let newDepartments: string[];

    if (checked) {
      newDepartments = [...selectedDepartments, departmentId];
    } else {
      newDepartments = selectedDepartments.filter(id => id !== departmentId);
      // If removing the primary department, set a new primary if possible
      if (departmentId === primaryDepartment && newDepartments.length > 0) {
        onChangePrimary(newDepartments[0]);
      }
    }

    onChange(newDepartments);
  };

  const handleSetPrimary = (departmentId: string) => {
    // If not already selected, add it to the selections
    if (!selectedDepartments.includes(departmentId)) {
      onChange([...selectedDepartments, departmentId]);
    }
    onChangePrimary(departmentId);
  };

  // Sort departments by name
  const sortedDepartments = [...departments].sort((a, b) => 
    a.departmentName.localeCompare(b.departmentName)
  );

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        {sortedDepartments.map((department) => (
          <div key={department.id} className="flex items-center gap-2">
            <div className="flex items-center space-x-2">
              <Checkbox 
                id={`dept-${department.departmentCode}`}
                checked={selectedDepartments.includes(department.departmentCode)}
                onCheckedChange={(checked) => 
                  handleToggleDepartment(department.departmentCode, checked === true)
                }
              />
              <Label 
                htmlFor={`dept-${department.departmentCode}`}
                className="cursor-pointer"
              >
                {department.departmentCode} - {department.departmentName}
              </Label>
            </div>
            
            {showPrimarySelector && selectedDepartments.includes(department.departmentCode) && (
              <label className="flex items-center space-x-2 ml-4 text-sm">
                <input
                  type="radio"
                  name="primaryDepartment"
                  checked={primaryDepartment === department.departmentCode}
                  onChange={() => handleSetPrimary(department.departmentCode)}
                  className="text-primary"
                />
                <span>Primary</span>
              </label>
            )}
          </div>
        ))}
      </div>
      
      {selectedDepartments.length === 0 && (
        <p className="text-sm text-muted-foreground">
          No departments selected. Please select at least one department.
        </p>
      )}
    </div>
  );
}
